import { AspectRatio } from '@chakra-ui/react';
import Loading from '../../utils/Loading';
import React from 'react';
import ReactDOM from 'react-dom';

// import '../../templates/vtex-apps/mz-styles-all.scss'
import './../../Canvas.scss';

//css do swiper tem que existir dentro do visualizationmode
const VisualizationIframe = ({ children, viewId, w, h }) => {
	const [ref, setRef] = React.useState();
	const [showLoading, setShowLoading] = React.useState(true);
	const container = ref?.contentWindow?.document?.body;
	const head = document.head;

	function handleOnLoad(e) {
		const target = e.target;
		if ((!!e?.target?.ownerDocument?.head || !!e?.target?.contentDocument?.head) && showLoading) {
			if (e?.target?.ownerDocument?.head) {
				const html = target.closest('html');
				html.getElementsByTagName('head')[0].innerHTML = head.innerHTML;
			} else {
				e.target.contentDocument.head = head.innerHTML;
			}
			setShowLoading(false);
		}
	}

	return (
		<>
			{showLoading && <Loading />}
			<AspectRatio w={w} h={h} _before={{ paddingBottom: 0 }}>
				<iframe ref={setRef} onLoad={handleOnLoad}>
					{container && ReactDOM.createPortal(<link rel="stylesheet" href="/iframeCss.css" />, container)}
					{container && !showLoading && ReactDOM.createPortal(children, container)}
					{/* {iframeHead && ReactDOM.createPortal(<Head/>, iframeHead)} */}
					{/* {container && ReactDOM.createPortal(<ImportSwiperCss/>, container)} */}
				</iframe>
			</AspectRatio>
		</>
	);
};

export default VisualizationIframe;
